__turbopack_context__.v({
  "cardCopy": "o0UDHq_cardCopy",
  "cardDesc": "o0UDHq_cardDesc",
  "cardImg": "o0UDHq_cardImg",
  "cardImgDesktop": "o0UDHq_cardImgDesktop",
  "cardImgMobile": "o0UDHq_cardImgMobile",
  "cardTitle": "o0UDHq_cardTitle",
  "carouselRegion": "o0UDHq_carouselRegion",
  "content": "o0UDHq_content",
  "copy": "o0UDHq_copy",
  "dot": "o0UDHq_dot",
  "dotActive": "o0UDHq_dotActive",
  "dotFill": "o0UDHq_dotFill",
  "dots": "o0UDHq_dots",
  "head": "o0UDHq_head",
  "media": "o0UDHq_media",
  "outer": "o0UDHq_outer",
  "slide": "o0UDHq_slide",
  "subtitle": "o0UDHq_subtitle",
  "tab": "o0UDHq_tab",
  "tabActive": "o0UDHq_tabActive",
  "tabHighlight": "o0UDHq_tabHighlight",
  "tabList": "o0UDHq_tabList",
  "title": "o0UDHq_title",
  "track": "o0UDHq_track",
  "viewport": "o0UDHq_viewport",
});
